module.exports = __webpack_public_path__ + "media/assets/images/flags/tr-1900da2ca2587a97f3af97c73381f680.svg";